import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper/modules';
import styles from '@components/ContentNavigation/ContentNavigationLinks/ContentNavigationLinks.styles';
import { IContentNavigation } from '@features/cms/typescript';
import Button from '@components/Button/Button';
import scrollToElementById from '@utils/scrollToElementById';
import 'swiper/css';
import 'swiper/css/free-mode';
type PropTypes = {
  links: IContentNavigation[];
};
const ContentNavigationLinks = ({
  links
}: PropTypes) => {
  return <div sx={styles.stickyLinks}>
      <Swiper direction="horizontal" modules={[Mousewheel, FreeMode]} followFinger slidesPerView="auto" freeMode mousewheel>
        <SwiperSlide>
          <div sx={styles.stickyLinksContent}>
            {links.map(link => <Button key={link.blockCode} variant="link" size="small" letterCase="uppercase" addSx={styles.linkButton(false)} onClick={() => scrollToElementById(link.blockCode)}>
                {link.text}
              </Button>)}
          </div>
        </SwiperSlide>
      </Swiper>
    </div>;
};
export default ContentNavigationLinks;